import React from "react";
import { Box, MainText } from "app/components/common";
import { ResponsiveValue } from "@shopify/restyle";
import { Theme } from "app/Theme/Theme";
import { Dimensions } from "react-native";

const { width } = Dimensions.get("window");

interface Props {
  text: string;
  icon?: React.ReactNode;
  marginRight?: ResponsiveValue<keyof Theme["spacing"], Theme>;
  marginLeft?: ResponsiveValue<keyof Theme["spacing"], Theme>;
  marginBottom?: ResponsiveValue<keyof Theme["spacing"], Theme>;
}

const Pill = ({
  text,
  icon,
  marginRight = "null",
  marginLeft = "null",
  marginBottom = "null",
}: Props) => {
  return (
    <Box
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      backgroundColor="neutral.transparent.white.20"
      borderColor="neutral.transparent.white.80"
      borderWidth={1}
      borderRadius={200}
      paddingHorizontal="xs"
      paddingVertical={2}
      marginRight={marginRight}
      marginLeft={marginLeft}
      marginBottom={marginBottom}
      maxWidth={width / 3}
    >
      {!!icon && icon}
      <MainText
        marginLeft={!!icon ? "xxs" : undefined}
        variant="l2-bold"
        color="neutral.white"
        numberOfLines={1}
      >
        {text}
      </MainText>
    </Box>
  );
};

export { Pill };
